import { createFeatureSelector, createReducer, on } from '@ngrx/store';

import type { StorageInformation } from '../../../pages/menu/device-settings/storage-management/components/storage-information/storage-information';
import { createScopedSelector } from '../../utils/factory.utils';

import { SettingsActions } from './settings.actions';

export const SETTINGS_STORE_KEY = 'settings';

// state
export interface SettingsState {
  storageInformation: StorageInformation;
  isConsentLoading: boolean;
  loading: boolean;
}

export const initialSettingsState: SettingsState = {
  storageInformation: {},
  isConsentLoading: false,
  loading: false,
};

// selectors
const selectSettingsState = createFeatureSelector<SettingsState>(SETTINGS_STORE_KEY);
const createSettingsSelector = createScopedSelector(selectSettingsState);

// reducers
export const settingsReducer = createReducer(
  initialSettingsState,

  on(
    SettingsActions.initStorageInformationSucceeded,
    (state, action): SettingsState => ({
      ...state,
      storageInformation: action.storageInformation,
    })
  ),
  on(
    SettingsActions.fetchConsentStarted,
    (state): SettingsState => ({
      ...state,
      isConsentLoading: true,
    })
  ),
  on(
    SettingsActions.fetchConsentSucceeded,
    (state): SettingsState => ({
      ...state,
      isConsentLoading: false,
    })
  ),
  on(
    SettingsActions.fetchConsentFailed,
    (state): SettingsState => ({
      ...state,
      isConsentLoading: false,
    })
  )
);

export const SettingsSelectors = {
  getStorageInformation: createSettingsSelector((state: SettingsState) => state.storageInformation),
  isConsentLoading: createSettingsSelector((state: SettingsState) => state.isConsentLoading),
};
